import { render, staticRenderFns } from "./ViewAdvertiser.vue?vue&type=template&id=a92c8b62"
import script from "./ViewAdvertiser.vue?vue&type=script&lang=js"
export * from "./ViewAdvertiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports